import { render, staticRenderFns } from "./EmployeeSector.vue?vue&type=template&id=0d6ddca2"
import script from "./EmployeeSector.vue?vue&type=script&lang=js"
export * from "./EmployeeSector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports